import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ModalsProvider } from '@speeki/global-ui-components';

import { ProfileData } from '@components/_global/Header/Profile/ProfileData/ProfileData';
import { ProfileItem } from '@components/_global/Header/Profile/ProfileItem/ProfileItem';

import { AuthService } from '@services/AuthService/AuthService';
import { getPath } from '@services/RouteService/paths';

import { useReactiveVar } from '@apollo/client';
import { tenantModulesVar } from '@boot/reactiveVariables';

import { ProfileDropdownWrapper } from './ProfileDropdown.styled';

interface ProfileDropdownProps {
    setIsOpen: (isOpen: boolean) => void;
}

export const ProfileDropdown = ({ setIsOpen }: ProfileDropdownProps) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const isSubsidiarySiteEnabled =
        useReactiveVar(tenantModulesVar).subsidiarySites;

    return (
        <ProfileDropdownWrapper setIsOpen={setIsOpen}>
            <ProfileData />
            <ProfileItem
                actionName={t('SETTINGS')}
                icon={'SvgSettings24'}
                isArrow
                isTopDivider
                onClick={() => navigate(getPath({ path: '/settings' }))}
                testId="CVtV0Js"
            />
            {isSubsidiarySiteEnabled && (
                <ProfileItem
                    actionName={t('CHANGE_SUBSIDIARY_SITE')}
                    icon={'SvgBriefcase24'}
                    isArrow
                    isTopDivider
                    onClick={() => ModalsProvider.open('EntityChangeModal')}
                    testId="1DGEZoe"
                />
            )}
            <ProfileItem
                actionName={t('CHANGE_COMPANY_TEXT')}
                icon={'SvgCompany24'}
                isArrow
                onClick={() => ModalsProvider.open('CompanyChangeModal')}
                testId="NYGdXaW"
            />
            <ProfileItem
                actionName={t('LOGOUT')}
                icon={'SvgLogout24'}
                onClick={() => AuthService.logout(true)}
                testId="a1fXlzb"
            />
        </ProfileDropdownWrapper>
    );
};
